import axios from 'axios'

axios.defaults.baseURL = `${process.env.NEXT_PUBLIC_API_URL}api/v1/`
axios.interceptors.request.use(
  (config) => {
    const { headers } = config
    headers['Accept'] = '*/*'
    headers['Content-Type'] = 'application/mediamagic.rest.v1+json'
    return config
  },
  (err) => Promise.reject(err)
)
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.data?.message?.includes('no jwk key found for kid')) {
      await localStorage.removeItem('session')
    }
    return Promise.reject(error)
  }
)

const http = axios

export default http
